<template>
  <sweet-modal width="600px" title="Create Tax" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left" label-width="120px">
      <el-form-item size="mini" prop="taxTypeId" :label="$t('modal_taxLibraries')">
        <el-select v-model="form.taxTypeId" :placeholder="$t('modal_taxLibraries')" style="width: 300px;" @change="handleSelectTaxType">
          <el-option
              v-for="type in taxTypes"
              :key="type.id"
              :label="type.name"
              :value="type.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="mini" prop="taxId" :label="$t('modal_taxCode')">
        <el-select :disabled="!form.taxTypeId" v-model="form.taxId" :placeholder="$t('modal_taxCode')" style="width: 300px;">
          <el-option
              v-for="type in taxes"
              :key="type.id"
              :label="type.name"
              :value="type.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button @click="create('form')" type="primary">{{$t('general_create')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "CreateTaxAccountModal",
  components: {
    SweetModal
  },
  data() {
    return {
      form: {
        taxTypeId: null,
        taxId: null
      },
      rules: {
        taxTypeId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        taxId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ]
      },
      taxTypes: [
        { id: 1, name: this.$t('settings_accountThink_taxTypes_taxes') },
        { id: 2, name: this.$t('settings_accountThink_taxTypes_withholdingTaxes') }
      ],
      taxes: [],
      params: {}
    }
  },
  methods: {
    openModal(params){
      console.log(params)
      this.params = params
      this.$refs.modal.open()
    },
    handleSelectTaxType(type) {
      this.form.taxId = null
      this.taxes = []
      let url = ''
      switch (type) {
        case 1:
          url = `/api/v1/projectTaxes/list?companyId=${this.$route.query.companyId}`
          break;
        case 2:
          url = `/api/v1/withholdingTaxes/list?companyId=${this.$route.query.companyId}`
          break;
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(url).then(response => {
        console.log(response)
        this.taxes = response.data.list
        loader.hide()
      }).catch(err => {
        console.log(err)
        loader.hide()
      })
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/account/addTax?accountId=${this.params.data.id}`, this.form).then(response => {
            console.log(response)
            this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_taxSuccessfullyCreated'), "success")
            this.$refs.modal.close()
            loader.hide()
            this.$emit('loadList', { entityType: 'account', id: this.params.data.id })
          }).catch(err => {
            console.log(err)
            loader.hide()
          })
        }
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    close() {
      this.form.taxTypeId = null
      this.form.taxId = null
      this.taxes = []
      this.params = {}
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style scoped>

</style>
